document.addEventListener('DOMContentLoaded', function() {
  const dateToggle = document.getElementById('dateToggle');
  const dateDropdown = document.getElementById('dateDropdown');
  const dateDisplay = document.getElementById('dateDisplay');
  const startDateInput = document.getElementById('start-date');
  const endDateInput = document.getElementById('end-date');
  const applyButton = document.getElementById('apply-dates');
  const clearButton = document.getElementById('clear-dates');
  const presetButtons = document.querySelectorAll('.preset-btn');

  function getNZDate() {
    const nzOptions = { timeZone: 'Pacific/Auckland' };
    const nzDateParts = new Date().toLocaleDateString('en-NZ', {
      ...nzOptions,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    }).split('/');
    return new Date(nzDateParts[2], nzDateParts[1] - 1, nzDateParts[0]);
  }

  function formatDateForInput(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Set min date to today
  const today = getNZDate();
  startDateInput.min = formatDateForInput(today);
  endDateInput.min = formatDateForInput(today);

  // Toggle dropdown
  dateToggle.addEventListener('click', function() {
    const isExpanded = dateToggle.getAttribute('aria-expanded') === 'true';
    dateToggle.setAttribute('aria-expanded', !isExpanded);
    dateDropdown.classList.toggle('show');
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!dateToggle.contains(e.target) && !dateDropdown.contains(e.target)) {
      dateToggle.setAttribute('aria-expanded', 'false');
      dateDropdown.classList.remove('show');
    }
  });

  // Handle start date changes
  startDateInput.addEventListener('change', function() {
    const startDate = this.value;
    endDateInput.min = startDate;
    
    if (endDateInput.value && endDateInput.value < startDate) {
      endDateInput.value = startDate;
    }
    if (!endDateInput.value && startDate) {
      endDateInput.value = startDate;
    }
    updateDateDisplay();
  });

  // Handle preset buttons
  presetButtons.forEach(button => {
    button.addEventListener('click', function() {
      const days = this.dataset.days;
      const type = this.dataset.type;
      
      const start = getNZDate();
      let end = getNZDate();

      if (days) {
        if (days === '0') { // Today
          // Keep start and end as today
        } else {
          end = new Date(start);
          end.setDate(start.getDate() + parseInt(days));
        }
      } else if (type === 'weekend') {
        const currentDay = start.getDay();
        
        if (currentDay === 5) { // Friday
          // Already Friday, use today
        } else if (currentDay === 6) { // Saturday
          start.setDate(start.getDate() - 1);
        } else if (currentDay === 0) { // Sunday
          start.setDate(start.getDate() - 2);
        } else { // Monday to Thursday
          start.setDate(start.getDate() + (5 - currentDay));
        }
        
        end = new Date(start);
        end.setDate(start.getDate() + 2);
      } else if (type === 'month') {
        end = new Date(start.getFullYear(), start.getMonth() + 1, 0);
      }

      startDateInput.value = formatDateForInput(start);
      endDateInput.value = formatDateForInput(end);
      updateDateDisplay();
    });
  });

  function filterProducts() {
    const productGrid = document.querySelector('.collection-products');
    if (!productGrid) return;

    const products = Array.from(productGrid.children);
    const startDate = startDateInput.value;
    const endDate = endDateInput.value || startDate;

    products.forEach(product => {
      const productStartDate = product.dataset.startDate;
      const productEndDate = product.dataset.endDate;

      if (startDate) {
        product.style.display = (productStartDate <= endDate && productEndDate >= startDate) ? '' : 'none';
      } else {
        product.style.display = '';
      }
    });

    const countElement = document.querySelector('.product-count');
    if (countElement) {
      const visibleProducts = products.filter(p => p.style.display !== 'none').length;
      countElement.textContent = `${visibleProducts} events`;
    }
  }

  function updateDateDisplay() {
  const start = startDateInput.value;
  const end = endDateInput.value;

  // Add or remove has-value class based on whether dates are selected
  if (start || end) {
    startDateInput.classList.add('has-value');
    endDateInput.classList.add('has-value');
  } else {
    startDateInput.classList.remove('has-value');
    endDateInput.classList.remove('has-value');
  }

  dateDisplay.textContent = !start && !end ? 'Select dates' :
    start === end || !end ? formatDate(start) :
    `${formatDate(start)} - ${formatDate(end)}`;
}
  
  function formatDate(dateStr) {
    return new Date(dateStr).toLocaleDateString('en-NZ', {
      month: 'short',
      day: 'numeric'
    });
  }

  // Apply date filter
  applyButton.addEventListener('click', function() {
    if (startDateInput.value && !endDateInput.value) {
      endDateInput.value = startDateInput.value;
    }
    filterProducts();
    dateDropdown.classList.remove('show');
    dateToggle.setAttribute('aria-expanded', 'false');
  });

// Clear date filter
clearButton.addEventListener('click', function() {
  startDateInput.value = '';
  endDateInput.value = '';
  startDateInput.classList.remove('has-value');
  endDateInput.classList.remove('has-value');
  const products = document.querySelectorAll('.collection-products > *');
  products.forEach(product => product.style.display = '');
  updateDateDisplay();

  const countElement = document.querySelector('.product-count');
  if (countElement) {
    countElement.textContent = `${products.length} events`;
  }
});

// Check for initial values when page loads
if (startDateInput.value || endDateInput.value) {
  startDateInput.classList.add('has-value');
  endDateInput.classList.add('has-value');
}
});